import React from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface AuthorizedSignCheckboxProps {
  value: boolean;
  onChange: (value: boolean) => void;
  disabled: boolean;
  authorizedRep?: boolean;
}

export default function AuthorizedSignCheckbox({
  value,
  onChange,
  disabled,
  authorizedRep,
}: AuthorizedSignCheckboxProps) {
  const { t } = useTranslation();

  return (
    <FormControlLabel
      control={
        <Checkbox
          id='authorized-sign-checkbox'
          checked={value}
          onChange={(e) => onChange(e.target.checked)}
          disabled={disabled}
        />
      }
      label={
        authorizedRep
          ? t('labels.authorizedRepresentative')
          : t('formInputs.authorizedSignInputLabel')
      }
    />
  );
}
